import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { PublishedConnectionTooltip } from '../Tooltips/PublishedConnectionTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export const PublishedConnectionDefaultImageUrl = imgPath('spaces_masthead_published_connection.svg');

export class PublishedConnectionCard extends ContentCard {
  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.publishedConnectionTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={PublishedConnectionDefaultImageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {this.props.content.name}
          </span>
          {this.showFavoritesStar() && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'publishedConnection' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'publishedConnection' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <PublishedConnectionTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
      />
    );
  }
}
